import { vfClassName } from './elements.js';
import { errorMessage, isObjEmpty, getType, isNodeList, getErrorElement } from './common.js';



/**
*** 指定した要素の value を取得する
*** @param {*} el
*** @returns object
**/

export function getValue( target )
{
  if( !target || !isNodeList(target) && getType(target) === 'button' ) return;


  // NodeList だとエラーが出るので HTMLCollection に置き換える
  const element = isNodeList(target) ? target[0] : target;

  // 親要素の取得
  const errorElement = getErrorElement( element.name, Validations.group ),
        parent = (errorElement && errorElement.hasAttribute('data-no-parent')) ? false : element.closest( vfClassName.parent );

  // 小見出し（label）要素の取得のために祖先要素を取得する
  const elemLabel = element.closest( vfClassName.subtitleParent ),
        tag = elemLabel ? elemLabel.querySelector( vfClassName.subtitle ) : null;

  // エラー箇所のスクロールトップを取得
  const rect = parent ? parent.getBoundingClientRect() : null,
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;



  const obj = {
    name    : null,
    value   : null,
    title   : (parent) ? parent.querySelector(vfClassName.title).textContent : null,
    subtitle: (tag) ? tag.textContent : null,
    worth   : null,
    dupli   : element.dataset.dupli !== undefined ? true : null,
    scroll  : parent ? rect.top + scrollTop : null
  };

  // チェックボックスの value & worth の容れ物
  let arrValue = [],
      arrWorth = [];



  // 複数あるチェックボックスかラジオボタン
  if( isNodeList(target) ){

    for( const item of target ){

      // ラジオボタン
      if( item.type === 'radio' ){
        if( item.checked ){
          obj.name  = item.name;
          obj.value = item.value;
          obj.worth = item.nextElementSibling.textContent;
          break;
        }
      }
      // チェックボックス
      if( item.type === 'checkbox' ){
        if( item.checked ){
          arrValue.push( item.value );
          arrWorth.push( item.nextElementSibling.textContent );
        }
        obj.name  = item.name;
        obj.value = arrValue.join(',');
        obj.worth = arrWorth.join(',');
      }
    }
  }
  else {
    // ラジオボタン
    if( target.type === 'radio' || target.type === 'checkbox' ){
      obj.name  = target.name;
      obj.value = target.checked ? target.value : null;
      obj.worth = target.checked ? target.nextElementSibling.textContent : null;
    }
    // セレクトボックス
    else if( target.type === 'select-one' ){
      const index = target.selectedIndex;
      obj.name  = target.name;
      // disabled 属性が false のものだけ取得
      if( target[index].disabled === false ){
        obj.value = target[index].value;
        obj.worth = target[index].textContent;
      }
    }
    else {
      obj.name  = target.name;
      obj.value = target.value ? target.value : null;
    }
  };

  return obj;
}
